import { default as Thumb } from './FeaturedDeviationThumb';
import { withFeatureBranch } from '@wix/da-shared-react/pkg/redux/flags';
import Thumb__premium_folders from '../Thumb__premium_folders';

export default withFeatureBranch({
  premium_folders: Thumb__premium_folders,
})(Thumb);
